import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
}), 'LocalBar');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalBar.js
// module id = 4541
// module chunks = 2